'use client';

import React, { useState } from 'react';

import { Dialog, type DialogProps } from '@backyard-ui/core';

import { Carousel } from '@/presenters/components/common/Carousel';

import type { MediaItem } from '../Medias';

import { Item } from './Item';

interface GalleryModalProps
  extends Pick<DialogProps, 'isOpen' | 'onOpenChange'> {
  title: string;
  startIndex: number;
  items: MediaItem[];
}

function GalleryModal(props: GalleryModalProps) {
  const { isOpen, title, onOpenChange, startIndex, items } = props;

  const [currentIndex, setCurrentIndex] = useState(startIndex);

  return (
    <Dialog.Root
      isCentered
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="2xl"
      data-testid="gallery"
    >
      <Dialog.Content>
        <Dialog.CloseButton />
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description>
          <Carousel
            controls={{ arrows: true, dots: true }}
            onSlideChange={(prev) => setCurrentIndex(prev)}
            options={{ startIndex }}
          >
            {items.map(({ alt, thumbSrc, type, videoId }, index) => (
              <Item
                key={index}
                alt={alt}
                thumbSrc={thumbSrc}
                type={type}
                videoId={videoId}
                isActive={index === currentIndex}
              />
            ))}
          </Carousel>
        </Dialog.Description>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export default GalleryModal;
